<template>
    <div>
        <b-modal :id="id" size="none">
            <template v-slot:modal-header="{ close }">
                <h3 class="w-100 text-center">{{ title }}</h3>
                <button type="button" class="close" @click="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <template v-slot:default>
                <p class="text-break">
                    <strong>{{ note.title }}</strong>
                </p>
                <p class="text-break">
                    {{ note.content }}
                </p>
                {{ __("added_by") }}: <strong>{{ note.author }}</strong> |
                {{ note.created_at }}
            </template>
            <template v-slot:modal-footer>
                <button
                    type="button"
                    class="btn btn-white"
                    @click="closeModal()"
                >
                    {{ __("cancel") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "modal-note-preview",

    data: () => ({
        note: {}
    }),
    props: {
        id: {
            type: String,
            default: "modal"
        },
        title: String
    },
    methods: {
        openModal(note) {
            this.$bvModal.show(this.id);
            this.note = note;
        },
        closeModal() {
            this.$bvModal.hide(this.id);
            this.note = {};
        },
        apply() {
            this.$emit("apply");
        }
    }
};
</script>
